import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import AutoSaveColorSelector from "../forms/AutoSaveFormFields/AutoSaveColorSelector";
import {isNoU} from "../../utils/DBUtils";

const mapStateToProps = (state) => {
    let currentEditBreakId = state.editBreak.break ? state.editBreak.break[state.editBreak.currentPlatform] : null;
    let currentEditBreak;
    let breakColors = [];
    // console.log(state.resources.resources[state.editBreak.break[state.editBreak.currentPlatform]].lang);

    if (!isNoU(currentEditBreakId)) {
        currentEditBreak = state.resources.resources[currentEditBreakId];

        breakColors = [];
        if ( currentEditBreak.missionColor1 ) { breakColors.push(currentEditBreak.missionColor1); }
        if ( currentEditBreak.missionColor3 ) { breakColors.push(currentEditBreak.missionColor3); }
        if ( currentEditBreak.missionColor5 ) { breakColors.push(currentEditBreak.missionColor5); }
        if ( currentEditBreak.missionColor6 ) { breakColors.push(currentEditBreak.missionColor6); }
        if ( currentEditBreak.missionColor7 ) { breakColors.push(currentEditBreak.missionColor7); }
        if ( currentEditBreak.replayColor ) { breakColors.push(currentEditBreak.replayColor); }
        if ( currentEditBreak.questionNavColor ) { breakColors.push(currentEditBreak.questionNavColor); }
        if ( currentEditBreak.questionNavTextColor ) { breakColors.push(currentEditBreak.questionNavTextColor); }
        if ( currentEditBreak.questionNavCorrectColor ) { breakColors.push(currentEditBreak.questionNavCorrectColor); }
        if ( currentEditBreak.questionNavIncorrectColor ) { breakColors.push(currentEditBreak.questionNavIncorrectColor); }
        if ( currentEditBreak.termsColor ) { breakColors.push(currentEditBreak.termsColor); }

        if (!isNoU(currentEditBreak.backgroundColor)) {
          breakColors.unshift(currentEditBreak.backgroundColor);
        }

        if (!isNoU(currentEditBreak.sponsor)) {
          breakColors.push(currentEditBreak.sponsor);
        }
        
    }


    return ({
        breakColors: breakColors
    });

}

const AutoSaveColorInputConnected = connect(mapStateToProps, null);

const AutoSaveColorInputComposed = compose(
    AutoSaveColorInputConnected
)(AutoSaveColorSelector);

export default AutoSaveColorInputComposed;



// WEBPACK FOOTER //
// ./public/components/composites/AutoSaveColorInputConnected.jsx